module.exports = __webpack_public_path__ + "static/img/product_3.90364bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/product_3.png
// module id = 3Pr8
// module chunks = 15